export default {
  backgroundColor: 'transparent',
  color: `transparent`,
  textDecoration: `none`,
  userSelect: `none`,
  cursor: `pointer`,
  whiteSpace: `pre`,
  transition: `all 250ms ease`,
  borderRadius: '100%',
  p: 0,
  ':visited': {
    color: 'transparent'
  },
  ':hover': {
    color: 'transparent'
  },
  'svg': {
    borderRadius: '100%'
  }
}
